<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item prop="applyType">
                <span slot="label" ><a-tooltip>{{ $t('申请类型') }}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                <a-select v-model="queryParam.applyType" :placeholder="$t('请选择')+'申请类型'" allow-clear @change="handleQuery">
                  <a-select-option :value="10">COSER</a-select-option>
                  <a-select-option :value="20">摄影师</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item prop="cnName">
                <span slot="label" ><a-tooltip>{{ $t('CN名称') }}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                <a-input v-model="queryParam.cnName" :maxLength="32" :placeholder="$t('请输入')+'CN名称'" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item prop="roleName">
                <span slot="label" ><a-tooltip>{{ $t('认证角色名称') }}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                <a-input v-model="queryParam.roleName" :maxLength="32" :placeholder="$t('请输入')+'认证角色名称'" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item prop="realName">
                  <span slot="label" ><a-tooltip>{{ $t('真实姓名') }}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-input v-model="queryParam.realName" :maxLength="32" :placeholder="$t('请输入')+'真实姓名'" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item prop="phone">
                  <span slot="label" ><a-tooltip>{{ $t('联系方式') }}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-input v-model="queryParam.phone" :maxLength="32" :placeholder="$t('请输入')+'联系方式'" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item prop="auditReason">
                  <span slot="label" ><a-tooltip>{{ $t('审核原因') }}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-input v-model="queryParam.auditReason" :maxLength="32" :placeholder="$t('请输入')+'审核原因'" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item prop="scoreReward">
                  <span slot="label" ><a-tooltip>{{ $t('审核通过奖励积分') }}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-input v-model="queryParam.scoreReward" :maxLength="32" :placeholder="$t('请输入')+'审核通过奖励积分'" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                  <a-date-picker
                    style="width: 100%"
                    v-model="queryParam.createBeginTime"
                    :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                    valueFormat="YYYY-MM-DD HH:mm:ss"
                    allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                  <a-date-picker
                    style="width: 100%"
                    v-model="queryParam.createEndTime"
                    :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                    valueFormat="YYYY-MM-DD HH:mm:ss"
                    allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('收起') : $t('展开') }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" :z-index="2000" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
        <!-- 查看全部角色图片弹框 -->
        <a-modal
          :visible="allImagesVisible"
          :title="$t('角色图片')"
          :footer="null"
          :z-index="1000"
          width="720px"
          @cancel="allImagesVisible = false">
          <div class="role-image-all">
            <img
              v-for="(img, idx) in allImages"
              :key="idx"
              :src="img"
              class="role-image-all-item"
              alt="角色图片"
              @click="handleRecordPreview(img)" />
          </div>
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['community:communitygroupactivitycoserapply:add']">
          <a-icon type="plus" />{{ $t('新增') }}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['community:communitygroupactivitycoserapply:edit']">
          <a-icon type="edit" />{{ $t('修改') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['community:communitygroupactivitycoserapply:remove']">
          <a-icon type="delete" />{{ $t('删除') }}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['community:communitygroupactivitycoserapply:export']">
          <a-icon type="download" />{{ $t('导出') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: 2000 }"
        id="draggable-table"
        class="draggable-table"
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="applyStatus" slot-scope="text, record">
          <span v-if="record.applyStatus == 0">{{ $t('待审核') }}</span>
          <span v-else-if="record.applyStatus == 1">{{ $t('已通过') }}</span>
          <span v-else-if="record.applyStatus == 2">{{ $t('已拒绝') }}</span>
          <span v-else>{{ record.applyStatus }}</span>
        </span>
        <span slot="roleImages" slot-scope="text, record">
          <div v-if="parseRoleImages(record.roleImages).length" class="role-image-list">
            <!-- 列表只展示第一张缩略图，点击放大预览 -->
            <img
              :src="parseRoleImages(record.roleImages)[0]"
              class="role-image-thumb"
              alt="角色图片"
              @click="handleRecordPreview(parseRoleImages(record.roleImages)[0])" />
            <!-- 多于一张时显示「查看更多」按钮，点击查看全部 -->
            <a
              v-if="parseRoleImages(record.roleImages).length > 1"
              class="role-image-more"
              @click="handleShowAllImages(parseRoleImages(record.roleImages))">
              {{ $t('查看更多') }}({{ parseRoleImages(record.roleImages).length }})
            </a>
          </div>
          <span v-else>{{ $t('暂无图片') }}</span>
        </span>
        <span slot="applyType" slot-scope="text, record">
          <span v-if="record.applyType == 10">COSER</span>
          <span v-else-if="record.applyType == 20">{{ $t('摄影师') }}</span>
          <span v-else>{{ record.applyType }}</span>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['community:communitygroupactivitycoserapply:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['community:communitygroupactivitycoserapply:edit']">
            <a-icon type="edit" />{{ $t('修改') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['community:communitygroupactivitycoserapply:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['community:communitygroupactivitycoserapply:remove']">
            <a-icon type="delete" />{{ $t('删除') }}
       </a>
         <template v-if="record.applyStatus == 0">
            <a-divider type="vertical" />
            <a @click="handleAudit(record)" v-hasPermi="['community:communitygroupactivitycoserapply:edit']">
              <a-icon type="check-circle" />{{ $t('审核') }}
            </a>
          </template>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
      <!-- 审核弹框 -->
      <a-modal
        :visible="auditModalVisible"
        :title="$t('审核申请')"
        @cancel="auditModalVisible = false"
        :footer="null"
      >
        <p>{{ auditRow && auditRow.applyType == 20 ? $t('确认该摄影师申请审核通过？') : $t('确认该COSER申请审核通过？') }}</p>
                <div style="margin-top: 24px; border-top: 1px solid #f0f0f0; padding-top: 16px; text-align: right">
          <a-button type="primary" @click="handleAuditApprove">
            {{ $t('确定') }}
          </a-button>
          <a-button style="margin-right: 8px" @click="handleAuditReject">
            {{ $t('拒绝') }}
          </a-button>
          <a-button style="margin-right: 8px" @click="auditModalVisible = false">
            {{ $t('取消') }}
          </a-button>
        </div>
     </a-modal>
      <!-- 拒绝原因输入弹框 -->
      <a-modal
        :visible="rejectModalVisible"
        :title="$t('拒绝审核')"
        @cancel="rejectModalVisible = false"
        :footer="null"
      >
        <p>{{ $t('请输入拒绝原因：') }}</p>
        <a-textarea
          v-model="rejectReason"
          :rows="4"
          :placeholder="$t('请输入拒绝原因')"
          style="margin-top: 8px"
        />
        <div style="margin-top: 24px; border-top: 1px solid #f0f0f0; padding-top: 16px; text-align: right">
          <a-button style="margin-right: 8px" @click="rejectModalVisible = false">
            {{ $t('取消') }}
          </a-button>
          <a-button type="primary" @click="handleRejectConfirm">
            {{ $t('确定') }}
          </a-button>
        </div>
      </a-modal>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageCommunityGroupActivityCoserApply, listCommunityGroupActivityCoserApply, delCommunityGroupActivityCoserApply, auditActivityApply } from '@/api/community/communityGroup/communityGroupActivityCoserApply'
import CustomDictTag from '@/components/DictCustomTag'
import { mapGetters } from 'vuex'
import moment from 'moment'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'CommunityGroupActivityCoserApply',
  components: {
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      // 预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 查看全部角色图片
      allImagesVisible: false,
      allImages: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
     // 审核弹框
     auditModalVisible: false,
     auditRow: null,
      // 拒绝原因弹框
      rejectModalVisible: false,
      rejectReason: '',
      // 查询参数
      queryParam: {
        applyType: undefined,
        cnName: undefined,
        roleName: undefined,
        realName: undefined,
        phone: undefined,
        auditReason: undefined,
        scoreReward: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('编号'),
          dataIndex: 'id',
          width: 80,
          align: 'center'
        },
        {
          title: this.$t('活动ID'),
          dataIndex: 'activityId',
          width: 80,
          align: 'center'
        },
        {
          title: this.$t('申请类型'),
          dataIndex: 'applyType',
          width: 100,
          scopedSlots: { customRender: 'applyType' },
          align: 'center'
        },
        {
          title: this.$t('申请等级ID'),
          dataIndex: 'applyLevelId',
          width: 100,
          align: 'center'
        },
        {
          title: this.$t('CN名称'),
          dataIndex: 'cnName',
          width: 130,
          align: 'center'
        },
        {
          title: this.$t('认证角色名称'),
          dataIndex: 'roleName',
          width: 130,
          align: 'center'
        },
        {
          title: this.$t('角色图片'),
          dataIndex: 'roleImages',
          width: 200,
          scopedSlots: { customRender: 'roleImages' },
          align: 'center'
        },
        {
          title: this.$t('真实姓名'),
          dataIndex: 'realName',
          width: 130,
          align: 'center'
        },
        {
          title: this.$t('联系方式'),
          dataIndex: 'phone',
          width: 130,
          align: 'center'
        },
        {
          title: this.$t('审核状态'),
          dataIndex: 'applyStatus',
          width: 100,
          scopedSlots: { customRender: 'applyStatus' },
          align: 'center'
        },
        {
          title: this.$t('审核原因'),
          dataIndex: 'auditReason',
          width: 200,
          align: 'center'
        },
        {
          title: this.$t('审核通过奖励积分'),
          dataIndex: 'scoreReward',
          width: 80,
          align: 'center'
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          width: 160,
          align: 'center'
        },
        {
          title: this.$t('备注'),
          dataIndex: 'remark',
          width: 200,
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: 150,
          scopedSlots: { customRender: 'operation' },
          fixed: 'right',
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共') + total + this.$t('条')
    },
    /** 查询社区活动COSER申请列表 */
    getList () {
      this.loading = true
     pageCommunityGroupActivityCoserApply(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        applyType: undefined,
        cnName: undefined,
        roleName: undefined,
        realName: undefined,
        phone: undefined,
        auditReason: undefined,
        scoreReward: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField === 'createTime') {
          this.queryParam.sortField = 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = ''
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    /** 解析角色图片字段 role_images，兼容 JSON 数组字符串与数组两种格式，判空防 NPE */
    parseRoleImages (roleImages) {
      if (!roleImages) {
        return []
      }
      if (Array.isArray(roleImages)) {
        return roleImages
      }
      try {
        const arr = JSON.parse(roleImages)
        return Array.isArray(arr) ? arr : []
      } catch (e) {
        return []
      }
    },
    handleRecordPreview(url) {
      // 仅打开单图预览，保留「查看全部」弹框（单图预览 z-index 更高，叠在其上方）
      this.previewUrl = url
      this.previewImageVisible = true
    },
    /** 打开「查看全部角色图片」弹框，展示多张图片，点击单张可放大 */
    handleShowAllImages(images) {
      this.allImages = images || []
      this.allImagesVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
   /** 审核按钮操作 */
    handleAudit (row) {
      this.auditRow = row;
      this.auditModalVisible = true;
    },
    /** 审核弹框 - 通过 */
   handleAuditApprove () {
     var that = this;
     var row = that.auditRow;
     auditActivityApply({ id: row.id, auditStatus: 1, applyType: row.applyType })
       .then(() => {
         that.auditModalVisible = false;
         that.auditRow = null;
         that.getList();
         that.$message.success(that.$t('审核通过'), 3);
       });
   },
    /** 审核弹框 - 拒绝，打开拒绝原因输入弹框 */
    handleAuditReject () {
      var that = this;
      that.rejectReason = '';
      that.rejectModalVisible = true;
    },
    /** 拒绝原因弹框 - 确认拒绝 */
    handleRejectConfirm () {
      var that = this;
      var reason = that.rejectReason;
      var row = that.auditRow;
      if (!reason) {
        that.$message.error(that.$t('拒绝原因不能为空'));
        return;
      }
      auditActivityApply({ id: row.id, auditStatus: 2, auditReason: reason, applyType: row.applyType })
        .then(() => {
          that.rejectModalVisible = false;
          that.auditModalVisible = false;
          that.auditRow = null;
          that.getList();
          that.$message.success(that.$t('已拒绝'), 3);
        });
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      const reqData = { 'idList': this.ids }
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          return delCommunityGroupActivityCoserApply(reqData)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(message, 3)
          })
        },
        onCancel () {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('biz/admin/community/community/group/activity/coser/apply/export',
            that.queryParam
          , `社区活动COSER申请_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>

<style scoped>
/* 角色图片列：多张缩略图平铺展示 */
.role-image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  justify-content: center;
}
/* 缩略图统一样式，鼠标手型提示可点击放大预览 */
.role-image-thumb {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #f0f0f0;
  cursor: pointer;
  transition: transform 0.2s;
}
.role-image-thumb:hover {
  transform: scale(1.1);
}
/* 「查看更多」按钮样式 */
.role-image-more {
  display: inline-flex;
  align-items: center;
  margin-left: 4px;
  font-size: 12px;
  color: #1890ff;
  cursor: pointer;
}
.role-image-more:hover {
  text-decoration: underline;
}
/* 查看全部图片弹框：网格平铺，点击单张可放大 */
.role-image-all {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}
.role-image-all-item {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #f0f0f0;
  cursor: pointer;
  transition: transform 0.2s;
}
.role-image-all-item:hover {
  transform: scale(1.03);
}
</style>
